module.exports = __webpack_public_path__ + "img/신사답게행동해.78ef258c.png";